
import React, { Component, } from 'react';
import {Modal, ModalHeader, ModalBody, Card, CardBody, Button} from 'reactstrap';

var stringUtil = require('../../../../utils/string/stringUtil.js');
var dateUtil = require('../../../../utils/dateUtil/dateUtil.js');
const storefrontUtility = require('../../../../utils/domain/storefrontUtility.js');
const translator = require('../../../../utils/translator/translator.js');

class DispatchTimeDialogue extends Component
{

    constructor(props)
    {
        super(props);
        
        this.state = {};

        this.state.kitchenPrepWindow = 5;
        this.state.date = this.getLocalTodaysDate();
        this.state.hour = null;
        this.state.min = null;
        const timingConfigurations = storefrontUtility.getStorefrontById(this.props.sale.storefrontId).timingConfigurations;
        
        if(timingConfigurations && Array.isArray(timingConfigurations.orderIntervals) && timingConfigurations.orderIntervals.length > 0)
        {
            for (let index = 0; index < timingConfigurations.orderIntervals.length; index++) 
                timingConfigurations.orderIntervals[index] = timingConfigurations.orderIntervals[index] || 1;
            
            this.state.kitchenPrepWindow = timingConfigurations.orderIntervals[0];
        }
    }

    render()
    {
        const orderWindowButtons = [];
        const timingConfigurations = storefrontUtility.getStorefrontById(this.props.sale.storefrontId).timingConfigurations;
        if(timingConfigurations && Array.isArray(timingConfigurations.orderIntervals))
        {
            timingConfigurations.orderIntervals.forEach(orderInterval =>
                {
                    let windowTimeClassName = "btn-action";
                    if (this.state.kitchenPrepWindow == orderInterval)
                        windowTimeClassName = "btn-ok";

                    orderWindowButtons.push(<Button className={windowTimeClassName} style={{marginLeft:'5px'}}
                                                onClick={()=>
                                                {
                                                    if (this.state.kitchenPrepWindow == orderInterval)
                                                        return;

                                                    this.state.min = null;
                                                    this.state.kitchenPrepWindow = orderInterval;
                                                    this.setState({});
                                                }}>
                                                +{orderInterval}
                                            </Button>)
                })
        }

        return(<div style={{userSelect:'none'}}>
                    <Modal isOpen={true} backdrop={true} centered animation={false} fade={false} size='lg'>
                        <ModalHeader
                            close={
                                <div>
                                    <Button className="btn-cancel" onClick={()=>{this.props.onClose(false)}}>{translator.getLabel("cancel")}</Button>&nbsp;&nbsp;
                                    <Button className="btn-ok" onClick={()=>
                                    {
                                        var dispatchDateTime = this.state.date;
                                        dispatchDateTime = dateUtil.setHours(dispatchDateTime, this.state.hour);
                                        dispatchDateTime = dateUtil.setMinutes(dispatchDateTime, this.state.min);
                                        dispatchDateTime = dateUtil.convertToUTCStandard(dispatchDateTime);

                                        this.props.saleContext.updatedDispatchDateTime = dispatchDateTime;
                                        this.props.onClose(true);
                                    }}>{translator.getLabel("done")}</Button>
                                </div>
                            }
                        >
                            <span className="window-title">{translator.getLabel("dispatch_time")}</span>
                        </ModalHeader>

                        <ModalBody>
                            <table width="100%">

                                <tr style={{borderLeft:'1px solid #C0C0C0', borderRight:'1px solid #C0C0C0', 
                                            borderTop:'1px solid #C0C0C0', borderBottom:'1px solid #C0C0C0',
                                            background:'#F0F0F0'}}>
                                    <td style={{width:'33%', verticalAlign:'top', whiteSpace:'nowrap'}}>
                                        {this.renderDays()}
                                    </td>
                                    <td style={{width:'33%', borderLeft:'1px solid #C0C0C0', 
                                                verticalAlign:'top'}}>
                                        {this.renderHours()}
                                    </td>
                                    <td style={{width:'33%', borderLeft:'1px solid #C0C0C0', 
                                                verticalAlign:'top'}}>
                                        {this.renderMinutes()}
                                    </td>
                                </tr>
                                <tr>
                                    <td colSpan={3}>
                                        <div style={{textAlign:'center', marginTop:'10px'}}>
                                            {orderWindowButtons}
                                        </div>
                                    </td>
                                </tr>

                                <tr>
                                    <td colSpan={3}>
                                        {this.renderDispatchDateTime()}
                                    </td>
                                </tr>
                            </table>
                        </ModalBody>

                    </Modal>
                </div>);
    }

    renderDays()
    {
        var currentDate = dateUtil.addDays(this.getLocalTodaysDate(), -1);

        var components = [];
        for (var index = 0; index < 60; index++)
        {
            currentDate = dateUtil.addDays(currentDate, 1);
            var caption = dateUtil.formatDate(currentDate, "ddd DD MMM");
            if (dateUtil.isSame(currentDate, this.getLocalTodaysDate()))
                caption = translator.getLabel("today");

            var style = {};
            style.paddingTop = "10px";
            style.paddingBottom = style.paddingTop;
            style.paddingLeft = "20px";
            style.fontSize = "1.2rem";
            style.borderBottom = "1px solid #C0C0C0";

            var onClick = ()=> {};
            if (dateUtil.isSame(currentDate, this.state.date))
            {
                style.background = '#686868';
                style.color = '#F8F8F8';
            }
            else
            {
                let temp = currentDate;
                onClick = ()=>
                {
                    this.state.date = temp;
                    this.state.hour = null;
                    this.state.min = null;
                    this.setState({});
                }
            }

            components.push(<div style={style} onClick={onClick}>{caption}</div>)

        }

        return <div style={{height:'35vh', overflowY:'auto'}}>
                    {components}
               </div>
    }

    renderHours()
    {
        var components = [];
        
        for (var index = 0; index < 24; index++)
        {
            let localNow = dateUtil.convertToLocalStandard(dateUtil.getNow());
            localNow = dateUtil.setMinutes(localNow, 0);
            localNow = dateUtil.setSeconds(localNow, 0);

            let selectedDateAndTime = this.state.date;
            selectedDateAndTime = dateUtil.setHours(selectedDateAndTime, index);
            if (dateUtil.isBefore(selectedDateAndTime, localNow))
                continue;

            var hour = `${index}`.padStart(2, "0");

            var style = {};
            style.textAlign = "center";
            style.paddingTop = "10px";
            style.paddingBottom = style.paddingTop;
            style.paddingLeft = "10px";
            style.paddingRight = "10px";
            style.fontSize = "1.2rem";
            style.borderBottom = "1px solid #C0C0C0";

            if (this.state.hour == null)
                this.state.hour = index;

            var onClick = ()=> {};
            if (index == this.state.hour)
            {
                style.background = '#686868';
                style.color = '#F8F8F8';
            }
            else
            {
                let temp = index;
                onClick = ()=>
                {
                    this.state.hour = temp;
                    this.state.min = null;
                    this.setState({});
                }
            }

            components.push(<div style={style} onClick={onClick}>{hour}</div>)


        }

        return <div style={{height:'35vh', overflowY:'auto'}}>
                    {components}
               </div>
    }

    renderMinutes()
    {
        var components = [];
        
        for (var index = 0; index < 60; index = index+this.state.kitchenPrepWindow)
        {
            if (stringUtil.isStringNullOrEmpty(this.state.hour))
                continue;

            let localNow = dateUtil.convertToLocalStandard(dateUtil.getNow());
            localNow = dateUtil.setSeconds(localNow, 0);

            let selectedDateAndTime = this.state.date;
            selectedDateAndTime = dateUtil.setHours(selectedDateAndTime, this.state.hour);
            selectedDateAndTime = dateUtil.setMinutes(selectedDateAndTime, index);
            if (dateUtil.isSameOrBefore(selectedDateAndTime, localNow))
                continue;
    

            
            var minute = `${index}`.padStart(2, "0");

            var style = {};
            style.textAlign = "center";
            style.paddingTop = "10px";
            style.paddingBottom = style.paddingTop;
            style.paddingLeft = "10px";
            style.paddingRight = "10px";
            style.fontSize = "1.2rem";
            style.borderBottom = "1px solid #C0C0C0";

            if (this.state.min == null)
                this.state.min = index;

            var onClick = ()=> {};
            if (index == this.state.min)
            {
                style.background = '#686868';
                style.color = '#F8F8F8';
            }
            else
            {
                let temp = index;
                onClick = ()=>
                {
                    this.state.min = temp;
                    this.setState({});
                }
            }

            components.push(<div style={style} onClick={onClick}>{minute}</div>)


        }

        return <div style={{height:'35vh', overflowY:'auto'}}>
                    {components}
               </div>
    }

    renderDispatchDateTime()
    {
        var caption = <span>&nbsp;</span>;

        if (this.state.date != null && this.state.hour != null && this.state.min != null)
        {
            var dispatchDateTime = this.state.date;
            dispatchDateTime = dateUtil.setHours(dispatchDateTime, this.state.hour);
            dispatchDateTime = dateUtil.setMinutes(dispatchDateTime, this.state.min);
    
            caption = `${translator.getLabel("order_will_be_dispatched_at")} ${dateUtil.formatDate(dispatchDateTime, "HH:mm")} (${dateUtil.formatDate(dispatchDateTime, "hh:mm A")})`;
            if (!dateUtil.isSame(dateUtil.getDateComponent(dispatchDateTime), this.getLocalTodaysDate()))
                caption = `${translator.getLabel("order_is_scheduled_for_dispatch_on")} ${dateUtil.formatDate(dispatchDateTime, "DD MMM HH:mm")} (${dateUtil.formatDate(dispatchDateTime, "hh:mm A")})`;
        }
        
        return <div style={{marginTop:'20px', color:'#888888', textAlign:'center'}}>
                    {caption}
                </div>
    }

    getLocalTodaysDate()
    {
        return dateUtil.getDateComponent(dateUtil.convertToLocalStandard(dateUtil.getNow()))
    }
}

export default DispatchTimeDialogue;